import { type AddressModel } from '../models/address/address.model';

export const transformAddress = (address: AddressModel): string => {
    const { street, housenumber, city, zip, state, country }: AddressModel = address;
    const result: string[] = [];

    if (street !== undefined) {
        const validHouseNumber: string = housenumber !== undefined ? ` ${housenumber}` : '';
        result.push(`${street}${validHouseNumber}`);
    }

    if (city !== undefined || zip !== undefined) {
        const cityZip: string[] = [];

        if (zip !== undefined) {
            cityZip.push(zip);
        }

        if (city !== undefined) {
            cityZip.push(city);
        }

        result.push(cityZip.join(' '));
    }

    if (state !== undefined) {
        result.push(state);
    }

    if (country !== undefined) {
        result.push(country);
    }

    return result.join('<br />');
};
